import { TypeCardWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

import Card, { CardProps } from './Card'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import { typedLowerCase } from '@/siteBuilder/utils/text/mappers'

const MAP_PADDING = { Narrow: 'narrow', Intermediate: 'intermediate', Compact: 'compact', None: 'custom' }

const ContentfulCard = withContentful<TypeCardWithoutUnresolvableLinksResponse['fields'], CardProps>(Card, {
  children: (props) => {
    return <BlockRenderer block={props.fields.components} fieldPath={'.components'} />
  },
  background: (props) => (props.fields.background === 'White' ? undefined : typedLowerCase(props.fields.background)),
  padding: (props) => MAP_PADDING[props.fields.padding],
  borderRadius: (props) => typedLowerCase(props.fields.borderRadius),
  fullBleedImage: (props) => ({
    src: props.fields.fullBleedImage?.fields?.file?.url,
    width: props.fields.fullBleedImage?.fields?.file?.details?.image?.width,
    height: props.fields.fullBleedImage?.fields?.file?.details?.image?.height,
    alt: props.fields.fullBleedImage?.fields?.description,
  }),
  fullBleedImagePosition: (props) => {
    return {
      xs: typedLowerCase(props.fields?.xsFullBleedImagePosition),
      sm: typedLowerCase(props.fields?.smFullBleedImagePosition),
      md: typedLowerCase(props.fields?.mdFullBleedImagePosition),
      lg: typedLowerCase(props.fields?.lgFullBleedImagePosition),
      xl: typedLowerCase(props.fields?.xlFullBleedImagePosition),
    }
  },
  fullBleedContentAlignment: (props) => {
    return {
      xs: typedLowerCase(props.fields?.xsFullBleedContentAlignment),
      sm: typedLowerCase(props.fields?.smFullBleedContentAlignment),
      md: typedLowerCase(props.fields?.mdFullBleedContentAlignment),
      lg: typedLowerCase(props.fields?.lgFullBleedContentAlignment),
      xl: typedLowerCase(props.fields?.xlFullBleedContentAlignment),
    }
  },
  fullBleedTextAlignment: (props) => {
    return {
      xs: typedLowerCase(props.fields?.xsFullBleedTextAlignment),
      sm: typedLowerCase(props.fields?.smFullBleedTextAlignment),
      md: typedLowerCase(props.fields?.mdFullBleedTextAlignment),
      lg: typedLowerCase(props.fields?.lgFullBleedTextAlignment),
      xl: typedLowerCase(props.fields?.xlFullBleedTextAlignment),
    }
  },
  fullBleedImgCol: (props) => {
    return {
      xs: props.fields?.xsFullBleedImgCol,
      sm: props.fields?.smFullBleedImgCol,
      md: props.fields?.mdFullBleedImgCol,
      lg: props.fields?.lgFullBleedImgCol,
      xl: props.fields?.xlFullBleedImgCol,
    }
  },
  useInteractiveCard: (props) => props.fields?.useInteractiveCard,
  interactiveCardUrl: (props) => props.fields?.interactiveCardUrl,
  imageStyle: (props) => typedLowerCase(props.fields?.imageStyle)?.split(' ').join('_'),
  backgroundImageResizeOption: (props) => {
    return {
      xs: typedLowerCase(props.fields?.xsBackgroundImageResizeOptions),
      sm: typedLowerCase(props.fields?.smBackgroundImageResizeOptions),
      md: typedLowerCase(props.fields?.mdBackgroundImageResizeOptions),
      lg: typedLowerCase(props.fields?.lgBackgroundImageResizeOptions),
      xl: typedLowerCase(props.fields?.xlBackgroundImageResizeOptions),
    }
  },
  style: (props) => typedLowerCase(props.fields?.style),
  customBackgroundColor: (props) => props.fields?.customBackgroundColor,
  customBorderColor: (props) => props.fields?.customBorderColor,
})

export default ContentfulCard
